import { useState } from "react";
import { Link } from "react-router-dom";

export default function PracticeAreas() {
  const allAreas = [
    {
      title: "Corporate & Commercial Laws",
      desc: "Company incorporation (Private, Public, OPC, Section 8) • LLP formation and compliance • Corporate governance & secretarial compliance",
    },
    {
      title: "Civil Litigation & Dispute Resolution",
      desc: "Civil suits & trials • Injunctions & recovery suits • Declaratory & specific performance suits",
    },
    {
      title: "Criminal Law",
      desc: "Criminal trials & defence • FIR quashing • Bail & anticipatory bail",
    },
    {
      title: "Arbitration, Mediation & ADR",
      desc: "Domestic & international arbitration • Institutional arbitration • Drafting arbitration clauses",
    },
    {
      title: "Banking & Finance Laws",
      desc: "Loan documentation • Debt recovery proceedings • DRT & DRAT matters",
    },
    {
      title: "Insolvency & Bankruptcy",
      desc: "Corporate Insolvency Resolution Process (CIRP) • Liquidation proceedings • Representation before NCLT & NCLAT",
    },
    {
      title: "Mergers, Acquisitions & Joint Ventures",
      desc: "M&A advisory and transaction support • Due diligence and deal structuring • Joint venture agreements and partnerships",
    },
    {
      title: "Startup Advisory & Legal Structuring",
      desc: "Business incorporation and structuring • Funding documentation and term sheets • Intellectual property protection for startups",
    },
    {
      title: "Foreign Investment (FDI) & FEMA Matters",
      desc: "FDI compliance and approvals • FEMA advisory and remittances • Cross-border investment structuring",
    },
    {
      title: "Securities & Capital Markets Laws",
      desc: "IPO and securities issuance • SEBI compliance and regulations • Stock exchange listings and disclosures",
    },
    {
      title: "Due Diligence & Risk Assessment",
      desc: "Legal and financial due diligence • Risk identification and mitigation strategies • Compliance audits and assessments",
    },
    {
      title: "Drafting & Vetting of Commercial Agreements",
      desc: "Contract drafting and review • Vendor and supplier agreements • Service level agreements (SLAs)",
    },
    {
      title: "Shareholder & Partnership Disputes",
      desc: "Shareholder agreement disputes • Oppression and mismanagement cases • Partnership dissolution matters",
    },
    {
      title: "Competition & Antitrust Laws",
      desc: "Competition Commission of India (CCI) matters • Merger control and notifications • Anti-competitive practices advisory",
    },
    {
      title: "Public Interest Litigation (PIL)",
      desc: "Constitutional law matters • Environmental and social justice PILs • Human rights advocacy",
    },
    {
      title: "Service Law & Government Employment Matters",
      desc: "Service disputes and disciplinary proceedings • Pension and retirement benefits • Central Administrative Tribunal (CAT) matters",
    },
    {
      title: "Education Laws & Institutional Advisory",
      desc: "Educational institution compliance • UGC and AICTE matters • Student admission disputes",
    },
    {
      title: "Healthcare & Medical Negligence Laws",
      desc: "Medical negligence claims • Hospital licensing and compliance • Healthcare regulatory matters",
    },
    {
      title: "Insurance Laws & Claims Advisory",
      desc: "Insurance claim disputes • Policy interpretation and coverage • IRDAI regulatory compliance",
    },
    {
      title: "Infrastructure & Project Finance Laws",
      desc: "Project financing and documentation • PPP agreements and contracts • Infrastructure development advisory",
    },
    {
      title: "Energy, Power & Renewable Laws",
      desc: "Power purchase agreements • Renewable energy projects • Regulatory compliance in energy sector",
    },
    {
      title: "Data Protection & Privacy Laws",
      desc: "DPDP Act compliance • Data security and breach management • Privacy policy drafting",
    },
    {
      title: "Media, Entertainment & Sports Laws",
      desc: "Content licensing and distribution • Sports contracts and representation • Entertainment industry agreements",
    },
    {
      title: "International Arbitration & Cross-Border Disputes",
      desc: "ICC and LCIA arbitrations • Foreign award enforcement • Cross-border commercial disputes",
    },
    {
      title: "Customs & Excise Laws",
      desc: "Customs duty disputes • Import-export compliance • Excise duty matters",
    },
    {
      title: "Trade & Export-Import (EXIM) Laws",
      desc: "EXIM policy compliance • Trade remedies and anti-dumping • International trade agreements",
    },
    {
      title: "Maritime & Admiralty Laws",
      desc: "Shipping and cargo disputes • Maritime liens and mortgages • Charter party agreements",
    },
    {
      title: "NGO, Trust & Society Registration",
      desc: "NGO registration and compliance • Trust deed drafting • Society formation and governance",
    },
    {
      title: "Election & Political Laws Advisory",
      desc: "Election petition matters • Political party registration • Campaign finance compliance",
    },
    {
      title: "Legal Retainership & Corporate Advisory",
      desc: "Ongoing legal retainership services • In-house legal support • Strategic legal advisory",
    },
  ];

  const [visibleCount, setVisibleCount] = useState(6);
  const [showAll, setShowAll] = useState(false);

  const handleLoadMore = () => {
    if (showAll) {
      setVisibleCount(6);
      setShowAll(false);
      // Smooth scroll to top of section
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      setVisibleCount(allAreas.length);
      setShowAll(true);
    }
  };

  const displayedAreas = allAreas.slice(0, visibleCount);

  return (
    <section className="relative py-20 sm:py-24 bg-white">
      {/* divider */}
      <div className="absolute top-0 left-0 w-full h-px bg-[#123a6f]/15" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* HEADER */}
        <div className="max-w-3xl mb-16">
          <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-[#0b1c2d]">
            What We Do
          </h2>

          <p className="mt-3 text-lg font-semibold text-[#123a6f]">
            Our Practice Areas 37
          </p>

          <p className="mt-4 text-gray-700 leading-relaxed">
            We offer comprehensive legal services across{" "}
            <span className="font-semibold text-[#0b1c2d]">
             37 specialized practice areas
            </span>
            , ensuring expert guidance for individuals, businesses, and institutions.
          </p>
        </div>

        {/* CARDS */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {displayedAreas.map((area) => (
            <div
              key={area.title}
              className="
                group relative bg-white
                border border-[#123a6f]/20
                p-8 flex flex-col justify-between
                transition-all duration-300
                hover:shadow-xl hover:border-yellow-500
              "
            >
              {/* gold strip */}
              <div className="absolute left-0 top-0 h-full w-1 bg-yellow-500 opacity-0 group-hover:opacity-100 transition" />

              {/* CONTENT */}
              <div>
                <h3
                  className="
                  font-playfair
                  text-2xl
                  font-bold
                  text-[#0b1c2d]
                  mb-4
                  leading-snug
                  group-hover:text-[#123a6f]
                  transition
                "
                >
                  {area.title}
                </h3>

                <p className="text-sm text-gray-700 leading-relaxed">
                  {area.desc}
                </p>
              </div>

              {/* CTA */}
              <div className="mt-8">
                <Link
                  to="/practice-areas"
                  className="
                    inline-flex items-center gap-2
                    text-sm font-semibold
                    text-[#123a6f]
                    group-hover:text-yellow-500
                    transition
                  "
                >
                  Learn More
                  <span className="transform group-hover:translate-x-1 transition">
                    →
                  </span>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* LOAD MORE / SHOW LESS BUTTON */}
        <div className="mt-16 text-center">
          <button
            onClick={handleLoadMore}
            className="
              inline-flex items-center gap-3
              px-14 py-4
              bg-[#0b1c2d] text-white
              font-semibold tracking-wide
              hover:bg-yellow-500 hover:text-[#0b1c2d]
              transition-all duration-300
            "
          >
            {showAll ? "Show Less" : "Load More Practice Areas"}
            <span className="transform transition">
              {showAll ? "↑" : "↓"}
            </span>
          </button>
        </div>

        {/* VIEW ALL PAGE LINK */}
        {showAll && (
          <div className="mt-8 text-center">
            <Link
              to="/practice-areas"
              className="
                inline-flex items-center gap-2
                text-[#123a6f] font-semibold
                hover:text-yellow-500
                transition
              "
            >
              View Detailed Practice Areas Page
              <span className="transform hover:translate-x-1 transition">→</span>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
